export const formKeys = {
  questions: "questions",
  quesUid: "ques_uid",
  marksReceived: "marks_received",
  totalMarks: "totalMarks",
};
